var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueskyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 600 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.72 44.03C202.216 93.951 273.74 195.17 300 249.49C326.26 195.17 397.784 93.951 464.28 44.03C512.694 7.98 589.996 -22.37 589.996 76.07C589.996 95.69 578.9 247.16 572.16 268.28C549.56 339.67 476.36 359.18 410.56 347.52C523.36 367.56 555.56 432.52 487.16 497.52C356.74 621.56 310.76 448.99 301.7 417.28C300.58 413.4 300.06 411.62 300 413.38C299.94 411.62 299.42 413.4 298.3 417.28C289.24 448.99 243.26 621.56 112.84 497.52C44.44 432.52 76.64 367.56 189.44 347.52C123.64 359.18 50.44 339.67 27.84 268.28C21.1 247.16 10 95.69 10 76.07C10 -22.37 87.306 7.98 135.72 44.03Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueskyIcon);
export default __webpack_public_path__ + "static/media/bluesky-icon.d2702582cc3efe26315e382e73a9af71.svg";
export { ForwardRef as ReactComponent };